import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=54805736&scoped=true&"
import script from "./GalleryItem.vue?vue&type=script&lang=js&"
export * from "./GalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&id=54805736&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54805736",
  null
  
)

export default component.exports